import React from 'react'

import { Helmet } from 'react-helmet'

import './games.css'

const Games = (props) => {
  return (
    <div className="games-container10">
      <Helmet>
        <title>guzuv's games!</title>
        <meta
          name="description"
          content="epic games, adding some sub-regularly!"
        />
        <meta property="og:title" content="guzuv's games!" />
        <meta
          property="og:description"
          content="epic games, adding some sub-regularly!"
        />
        <link
          rel="canonical"
          href="https://site-time-hv38k4.teleporthq.app/games"
        />
      </Helmet>
      <div id="services" className="games-thq-services-elm">
        <div className="games-thq-service-card-elm1">
          <div className="games-thq-card-content-elm10">
            <h3 className="games-text100 BigCard-Heading">among us.</h3>
            <span className="games-text101 Card-Text">
              <span>
                amongus with multiplayer!
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>now with free chat, have fun!</span>
            </span>
            <a
              href="https://among-us-1tim.netlify.app/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link10 button"
            >
              sus much?
            </a>
          </div>
          <div className="games-thq-card-content-elm11">
            <h3 className="games-text105 BigCard-Heading">GBA emulator.</h3>
            <span className="games-text106 Card-Text">
              my own GBA emulator! updating at times! thanks Will for
              suggestion! 
            </span>
            <a
              href="https://guzuvy.github.io/GBA/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link11 button"
            >
              Have fun!
            </a>
          </div>
          <div className="games-thq-card-content-elm12">
            <h3 className="games-text107 BigCard-Heading">minecraft!</h3>
            <span className="games-text108">
              <span className="Card-Text">
                Minecraft, right in your browser! pick multiplayer to join with
                a friend.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <a
                href="https://guzuvy.github.io/mc/old.html"
                target="_blank"
                rel="noreferrer noopener"
              >
                old version here
              </a>
            </span>
            <a
              href="https://guzuvy.github.io/mc"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link13 button"
            >
              L -L- L- Lava!
            </a>
          </div>
          <div className="games-thq-card-content-elm13">
            <h3 className="games-text110 BigCard-Heading">super mario 64.</h3>
            <span className="games-text111 Card-Text">
              mario 64, with saves and everything! it&apos;s a bunch of fun,
              good luck!
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <a
              href="https://guzuvy.github.io/sm64/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link14 button"
            >
              wahoo!
            </a>
          </div>
          <div className="games-thq-card-content-elm14">
            <h3 className="games-text112 BigCard-Heading">Temple Run 2</h3>
            <span className="games-text113 Card-Text">
              run, jump, duck and dash as far as you can! Snag upgrades, and get
              that idol!
            </span>
            <a
              href="https://23azostore.github.io/s8/temple-run-2/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link15 button"
            >
              run forever!
            </a>
          </div>
          <div className="games-thq-card-content-elm15">
            <h3 className="games-text114 BigCard-Heading">multi-emulator.</h3>
            <span className="games-text115">
              <span className="Card-Text">so many emulators?! wowie!</span>
              <span className="Card-Text">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <a
                href="https://archive.org/download/nintendo-64-romset-usa"
                target="_blank"
                rel="noreferrer noopener"
              >
                rom
              </a>
              <span>s here.</span>
            </span>
            <a
              href="https://demo.emulatorjs.org/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link17 button"
            >
              *gaming time*
            </a>
          </div>
          <div className="games-thq-card-content-elm16">
            <h3 className="games-text119 BigCard-Heading">Sports Random</h3>
            <span className="games-text120">
              two players, one device, play to 5 points, now with randomness!
            </span>
            <div className="games-container11">
              <a
                href="https://guzuvy.github.io/BasketRandom/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link18 button"
              >
                Basketball
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbwr79gF5RqgUkBr0YEX16ayQF4aqdcHxaLRubcOggFvXqp-PiG7tw0uyvr3vlUEpDnC/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link19 button"
              >
                Soccer
              </a>
            </div>
            <div className="games-container12">
              <a
                href="https://guzuvy.github.io/boxing-random/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link20 button"
              >
                Boxing
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbySnSeOuxeNgXf_mRnxhgTNrI0GTf75ACkCgLZgNKFiH18b_MUvbqsW1x0wlUljppDQ/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link21 button"
              >
                Boxing
              </a>
            </div>
          </div>
          <div className="games-thq-card-content-elm17">
            <h3 className="games-text121 BigCard-Heading">subway surfers</h3>
            <span className="games-text122">
              dodge the Inspector, hoverboard it out, and run, run, and run in
              subway surfers!
            </span>
            <a
              href="https://guzuvy.github.io/sub-surf/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link22 button"
            >
              <span>
                <span>HEY!</span>
                <br></br>
              </span>
            </a>
          </div>
          <div className="games-thq-card-content-elm18">
            <h3 className="games-text126 BigCard-Heading">geometry dash!</h3>
            <span className="games-text127">
              get jumping, dodge the spikes, and don&apos;t get mad in geometry
              dash!
            </span>
            <a
              href="https://endis.rest/g/gd/index.html"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link23 button"
            >
              <span>
                <span>problem?</span>
                <br></br>
              </span>
            </a>
          </div>
          <div className="games-thq-card-content-elm19">
            <h3 className="games-text131 BigCard-Heading">tank trouble.</h3>
            <span className="games-text132">
              play with one or two buds on the same device! shoot, pickup op
              powerups, and beat your pals in Tank Trouble.
            </span>
            <a
              href="https://guzuvy.github.io/TankTrouble/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link24 button"
            >
              <span>
                <span>deathray too good.</span>
                <br></br>
              </span>
            </a>
          </div>
          <div className="games-thq-card-content-elm20">
            <h3 className="games-text136 BigCard-Heading">
              barry has a secret.
            </h3>
            <span className="games-text137">
              <span>
                barry seems to be hiding something, help him and don&apos;t let
                the cops find out!
              </span>
              <br></br>
            </span>
            <a
              href="https://vaxtangi1980.github.io/barry/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link25 button"
            >
              <span>
                <span>what are you hiding?</span>
                <br></br>
              </span>
            </a>
          </div>
          <div className="games-thq-card-content-elm21">
            <h3 className="games-text143">The World&apos;s Hardest Game</h3>
            <span className="games-text144">
              The classic flash game is back! try not to rage, and beat The
              World&apos;s Hardest Game.
            </span>
            <div className="games-container13">
              <a
                href="https://guzuvy.github.io/worlds-hardest-game/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link26 button"
              >
                <span>fear the blue dots!</span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbw44_giul3DgpDlfdjvZsCjUjhzT4pGb4w2bWXXC9h2OLB7YYQHhvx0_87wjZOI7gSedw/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link27 button"
              >
                <span>
                  <span>fear them 2</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-container14">
              <a
                href="https://script.google.com/macros/s/AKfycbzkSDummp1Gt_sxcHQ1aB9CouQ3BAgIXt6Ha_A37qlusGaHg8CuDJlErhb1J5YkwunqnQ/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link28 button"
              >
                <span>
                  <span>now its 3?!</span>
                  <br></br>
                </span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbwhZ8UArrc7PVzRXXs_N8GE11lmrE1gFASscoys_AclHvY2qGHsN2YMLP0XHpzCJRJyDQ/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link29 button"
              >
                <span>
                  <span>fear 4evr!!</span>
                  <br></br>
                </span>
              </a>
            </div>
          </div>
          <div className="games-thq-card-content-elm22">
            <h3 className="games-text155 BigCard-Heading">papa&apos;s games</h3>
            <span className="games-text156">
              papa&apos;s games, now not flash! take orders as fast as you can,
              make papa proud!
            </span>
            <div className="games-container15">
              <a
                href="https://script.google.com/macros/s/AKfycbyyfjHc-YiNqGOngfUlkjS5Fvx2x0UYfkerogM_Y3-Z1BQTZW2K0AcegLUtVdRjo5nM/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link30 button"
              >
                <span className="games-text157">burgers, yay!</span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbxN6EVQbtkjn6NUiIyJscLGTyyMyAUABzuB_kp4relIe6rr9B8eWmlnlvDsBVtiRa5pPg/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link31 button"
              >
                <span className="games-text158">pizza, yay!</span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbzyE60DnmZWbxpl4-QJfL3MRbJsXH6fp91mZFgLHokQtH1g2k3kM-j3pL8Br0B_4mZxog/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link32 button"
              >
                <span className="games-text159">pies, yay!</span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbzk2qDUZXuf897gGXEUFLwdWohXCG_EIWOKyIeJDNXIacvN9J-ycbf2_FSsig9IHcYJ/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link33 button"
              >
                <span className="games-text160">sushi, yay!</span>
              </a>
            </div>
            <div className="games-container16">
              <a
                href="https://script.google.com/macros/s/AKfycbyJDZUnBq6_qyG0CrInptybAP0n54yhZ8agPdAQ1iAT_ki0rfkTjHPSHYdfyOvO1Skwjw/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link34 button"
              >
                <span className="games-text161">tacos. yay!</span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbxN6EVQbtkjn6NUiIyJscLGTyyMyAUABzuB_kp4relIe6rr9B8eWmlnlvDsBVtiRa5pPg/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link35 button"
              >
                <span className="games-text162">slushies, yay!</span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbwGrleo0tXLaCWS1og97Dnvak20WOuSvox2xEIJKg_ZBF7EhsZsavi1OtqR4lGIGh5tlw/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link36 button"
              >
                <span className="games-text163">cupcakes, yay!</span>
              </a>
              <a
                href="https://script.google.com/macros/s/AKfycbz2GOzpADIEiCiDWKLUzE4Eob6-EXgOp-YeUiEd3vwiULGc-9LQOZ3CciIGMD30Z8w/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link37 button"
              >
                <span className="games-text164">wings, yay!</span>
              </a>
            </div>
          </div>
          <div className="games-thq-card-content-elm23">
            <h3 className="games-text165 BigCard-Heading">cod zombies.</h3>
            <span className="games-text166">
              just you, and the horde. how far can you survive? grab juggernog,
              you&apos;ll need it.
            </span>
            <a
              href="https://guzuvy.github.io/nzp/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link38 button"
            >
              <span>infected!</span>
            </a>
          </div>
          <div className="games-thq-card-content-elm24">
            <h3 className="games-text168 BigCard-Heading">grindcraft!</h3>
            <span className="games-text169">
              grindcraft, now remastered! grind, grind, and grind until you can
              make people grind for you!
            </span>
            <a
              href="https://mirathecat.github.io/grindcraft/index.html"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link39 button"
            >
              <span>minecraft rip-off?</span>
            </a>
          </div>
          <div className="games-thq-card-content-elm25">
            <h3 className="games-text171 BigCard-Heading">bloxorz.</h3>
            <span className="games-text172">
              play some fun, and challenging levels, now with a marbled block!
            </span>
            <a
              href="https://guzuvy.github.io/bloxorz"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link40 button"
            >
              <span>just get in there!</span>
            </a>
          </div>
          <div className="games-thq-card-content-elm26">
            <h3 className="games-text174 BigCard-Heading">SUPERHOT</h3>
            <span className="games-text175">
              <span>
                get thru the levels, and stand still to slow time!
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="games-text177">
                takes time to load be patient
              </span>
            </span>
            <a
              href="https://ajh.webauth.win.cdn.cloudflare.net/books/superhot/index.html"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link41 button"
            >
              <span>SUPERHOT</span>
            </a>
          </div>
          <div className="games-thq-card-content-elm27">
            <h3 className="games-text179 BigCard-Heading">slither.io</h3>
            <span className="games-text180">
              slither io, now with even more scratch! also has multiplayer.
            </span>
            <a
              href="https://lll69.github.io/turbo-warp-scratch-gui/fullscreen.html?interpolate&amp;hqpen#108566337"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link42 button"
            >
              <span>coil them in!</span>
            </a>
          </div>
          <div className="games-thq-card-content-elm28">
            <h3 className="games-text182 BigCard-Heading">happy wheels</h3>
            <span className="games-text183">
              a brutal classic, now here! make a level and challenge your
              friends to beat it.
            </span>
            <a
              href="https://script.google.com/macros/s/AKfycbyfMPVIGx6dJPrYKeE9e4Erj949-dH28pWVRjdV1vgnoylpBV8af03JNLoz2MwAIBLECg/exec"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link43 button"
            >
              <span>&quot;oh my legs&quot;</span>
            </a>
          </div>
          <div className="games-thq-card-content-elm29">
            <h3 className="games-text185 BigCard-Heading">miniDayZ</h3>
            <span className="games-text186">
              DayZ, reimagined as a topdown singleplayer experience. Survive!
            </span>
            <a
              href="https://nextdev65.github.io/MiniDayZ/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link44 button"
            >
              <span>rags to rope!</span>
            </a>
          </div>
          <div className="games-thq-card-content-elm30">
            <h3 className="games-text188 BigCard-Heading">Retro Bowl</h3>
            <span className="games-text189">
              Build a great team, and see how far you can toss a ball!
            </span>
            <a
              href="https://v6-f.knimedia.us/books/retro-bowl/index.html"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link45 button"
            >
              <span>TOUCHDOWN~</span>
            </a>
            <a
              href="https://4yqt7wrhtx-ship-it.github.io/driving-games/retro-bowl-college/"
              target="_blank"
              rel="noreferrer noopener"
              className="games-link46 button"
            >
              <span>College!!!</span>
            </a>
          </div>
        </div>
        <div className="games-container17">
          <div className="games-thq-service-card-elm2">
            <div className="games-thq-card-content-elm31">
              <h3 className="games-text192 BigCard-Heading">Doodle Jump.</h3>
              <span className="games-text193 Card-Text">
                jump as high as you can! can you beat 15000 score? good luck!
              </span>
              <a
                href="https://guzuvy.github.io/doodle-jump/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link47 Anchor button"
              >
                Get Jumping!
              </a>
            </div>
            <div className="games-thq-card-content-elm32">
              <h3 className="games-text194 BigCard-Heading">Doom!</h3>
              <span className="games-text195 Card-Text">
                get knee deep in hell, slaughter to victory! press any key to
                start. 
              </span>
              <a
                href="https://floooh.github.io/doom-sokol/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link48 button Anchor"
              >
                Rip and Tear!
              </a>
            </div>
            <div className="games-thq-card-content-elm33">
              <h3 className="games-text196 BigCard-Heading">
                friday night funkin&apos;
              </h3>
              <span className="games-text197">
                <span>friday night funkin, have fun!</span>
                <br></br>
              </span>
              <a
                href="https://map-l.github.io/play/fnf/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link49 button"
              >
                funkin time!
              </a>
            </div>
            <div className="games-thq-card-content-elm34">
              <h3 className="games-text200 BigCard-Heading">run</h3>
              <span className="games-text201">
                <span>
                  thanks bert for the idea! nostalgia trip and get all the dots!
                </span>
                <br></br>
              </span>
              <div className="games-container18">
                <a
                  href="https://script.google.com/macros/s/AKfycbwhQbabxqsWUj8FVuMKX-JY3y-i2X6KPZaHJWlxsCahODzz6dEQ0kV9sVLgs2p--Fi0/exec"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link50 button"
                >
                  <span>
                    <span>run</span>
                    <br></br>
                  </span>
                </a>
                <div className="games-container19">
                  <a
                    href="https://script.google.com/macros/s/AKfycbxJi3JRh5IrDvZUBcgefHXE5WhxJ2Ed3wtbyKkvZtyTjnzmgm_LCvaXY_GFsnOsknQvxg/exec"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="games-link51 button"
                  >
                    <span>
                      <span>run two</span>
                      <br></br>
                    </span>
                  </a>
                </div>
              </div>
              <a
                href="https://lekug.github.io/tn6pS9dCf37xAhkJv/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link52 button"
              >
                run three
              </a>
            </div>
            <div className="games-thq-card-content-elm35">
              <h3 className="games-text210 BigCard-Heading">tunnel rush!</h3>
              <span className="games-text211">
                <span>
                  dean gave me this idea. how long can you go, i was 7937m! it
                  will be blank, then it will load.
                </span>
                <br></br>
              </span>
              <a
                href="https://guzuvy.github.io/tunnelrushing/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link53 button"
              >
                <span>
                  <span>breakneck speeds!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm36">
              <h3 className="games-text217 BigCard-Heading">
                Fireboy And Watergirl
              </h3>
              <span className="games-text218">
                <span>
                  A 2 player classic, fireboy and water girl, get gems, dodge
                  the opposites, and sabotage your friends!
                </span>
                <br></br>
              </span>
              <a
                href="https://script.google.com/macros/s/AKfycbw8EVdUCzgTInevqT2h0DOxeN07fjoLrB5DowKa1TlhpqFnJ1IkViYJ7uV58-8yITGztg/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link54 button"
              >
                <span>
                  <span>Opposites Attract!</span>
                  <br></br>
                </span>
              </a>
              <div className="games-container20">
                <a
                  href="https://script.google.com/macros/s/AKfycbwIrLGisdXd9u7LLcbcwA8z2xAVENhn4kdkZWD8nIxUiWX0uH9fYtrLkVMgn7YNNik_/exec"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link55 button"
                >
                  <span>
                    <span>Play 2nd game</span>
                    <br></br>
                  </span>
                </a>
                <div className="games-container21">
                  <a
                    href="https://script.google.com/macros/s/AKfycbxU0AmnmxI5WDA0TT-Ygt55sVE7FwZxGdlmXrY3r1MuBA0Y_ovF4zhR51peOmVgOER_/exec"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="games-link56 button"
                  >
                    <span>
                      <span>Play 3rd Game</span>
                      <br></br>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className="games-thq-card-content-elm37">
              <h3 className="games-text230 BigCard-Heading">Iron snout.</h3>
              <span className="games-text231">
                <span>
                  last as long as you can, i got 21 dead on 1hp mode, can you
                  top that?
                </span>
                <br></br>
              </span>
              <a
                href="https://s3.eu-central-1.amazonaws.com/snoutupgames/ironsnout/index.html"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link57 button"
              >
                <span>
                  <span>making bacon!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm38">
              <h3 className="games-text237 BigCard-Heading">flappy bird.</h3>
              <span className="games-text238">
                <span>flap forever! (used to be a bounty)</span>
                <br></br>
              </span>
              <a
                href="https://s3-eu-west-1.amazonaws.com/apps.playcanvas.com/TAhlQLDa/index.html"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link58 button"
              >
                <span>
                  <span>Tap to flap!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm39">
              <h3 className="games-text244">
                <span className="games-text245 BigCard-Heading">
                  Baldi&apos;s Basics
                </span>
                <br></br>
              </h3>
              <span className="games-text247">
                <span>
                  snag notebooks, get sweep sweep sweeped, and escape in
                  baldi&apos;s basics!
                </span>
                <br></br>
              </span>
              <div className="games-container22">
                <a
                  href="https://map-l.github.io/play/baldis-basics-classic-remastered/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link59 button"
                >
                  <span>
                    <span>Classic Remastered</span>
                    <br></br>
                  </span>
                </a>
                <a
                  href="https://map-l.github.io/play/baldis-basics/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link60 button"
                >
                  <span>
                    <span>OG</span>
                    <br></br>
                  </span>
                </a>
              </div>
            </div>
            <div className="games-thq-card-content-elm40">
              <h3 className="games-text256">
                <span className="games-text257 BigCard-Heading">fnaf!</span>
                <br></br>
              </h3>
              <span className="games-text259">
                <span>
                  scratch version of fnaf, chromebooks can&apos;t handle the
                  real one.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
              </span>
              <div className="games-container23">
                <a
                  href="https://lll69.github.io/turbo-warp-scratch-gui/fullscreen.html?interpolate#323425823"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link61 button"
                >
                  <span>
                    <span>FNAF 1</span>
                    <br></br>
                  </span>
                </a>
                <a
                  href="https://lll69.github.io/turbo-warp-scratch-gui/fullscreen.html?interpolate#547735459"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link62 button"
                >
                  <span>
                    <span>FNAF 2</span>
                    <br></br>
                  </span>
                </a>
              </div>
              <div className="games-container24">
                <a
                  href="https://lll69.github.io/turbo-warp-scratch-gui/fullscreen.html?interpolate#548407369"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link63 button"
                >
                  <span>
                    <span>FNAF 3</span>
                    <br></br>
                  </span>
                </a>
                <a
                  href="https://watchdocumentaries.com/wp-content/uploads/games/five-nights-at-freddys/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link64 button"
                >
                  <span>
                    <span>FNAF 4</span>
                    <br></br>
                  </span>
                </a>
              </div>
            </div>
            <div className="games-thq-card-content-elm41">
              <h3 className="games-text274">
                <span className="BigCard-Heading">duck life</span>
                <br></br>
              </h3>
              <span className="games-text277">
                <span>get a duck, and make them a winner!</span>
                <br></br>
              </span>
              <div className="games-container25">
                <a
                  href="https://script.google.com/macros/s/AKfycbyNXKGLBu1Tg-9ORYPAQ7WsUyfR4vejcF5ShIY1FroLXGwKCAnhBKKLfUdr6fdQRL5NVA/exec"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link65 button"
                >
                  <span>
                    <span>Duck Life</span>
                    <br></br>
                  </span>
                </a>
                <a
                  href="https://script.google.com/macros/s/AKfycbxt1OfesayrpvZO0iyVbq-_DJAgydK1MtfKUflXEkxk8MUHBuV_GIo81yIQoNNiUAzbUA/exec"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link66 button"
                >
                  <span>
                    <span>Duck Life 2</span>
                    <br></br>
                  </span>
                </a>
              </div>
              <div className="games-container26">
                <a
                  href="https://script.google.com/macros/s/AKfycbxKC46TPtFqkQ8CyDyHSxOxthdFPI4de6mTUDZsmdXhUjxictSPiOGP0NEREVNrOH8P/exec"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link67 button"
                >
                  <span>
                    <span>Duck Life 3</span>
                    <br></br>
                  </span>
                </a>
                <a
                  href="https://script.google.com/macros/s/AKfycby2EtapHf3dWrR5iauSK_yeOo64MGUkkkxIbYCsQBrQN8rmxohGIAKF1U69foTGQsoj/exec"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="games-link68 button"
                >
                  <span>
                    <span>Duck Life 4</span>
                    <br></br>
                  </span>
                </a>
              </div>
            </div>
            <div className="games-thq-card-content-elm42">
              <h3 className="games-text292">
                <span className="BigCard-Heading">cookie clicker!</span>
                <br></br>
              </h3>
              <span className="games-text295">
                <span>
                  like cookies? click for cookies, and click for more cookies!
                  Now with cookie time machines!
                </span>
                <br></br>
              </span>
              <a
                href="https://guzuvy.github.io/cookieclicker/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link69 button"
              >
                <span>
                  <span>succumb to the cookie.</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm43">
              <h3 className="games-text301">
                <span className="BigCard-Heading">chess!</span>
                <br></br>
              </h3>
              <span className="games-text304">
                <span>simple chess, has bot and local gameplay.</span>
                <br></br>
              </span>
              <a
                href="https://www.cbc.ca/kidscbc2/content/games/master_board/chess/index.html"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link70 button"
              >
                <span>
                  <span>&quot;checkmate.&quot;</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm44">
              <h3 className="games-text310">
                <span className="BigCard-Heading">slope</span>
                <br></br>
              </h3>
              <span className="games-text313">
                <span>slope gaming! how far can you go, i hit 52 score.</span>
                <br></br>
              </span>
              <a
                href="https://lnahtml.github.io/a/slope/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link71 button"
              >
                <span className="games-text316">
                  <span>nyooom!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm45">
              <h3 className="games-text319">
                <span className="BigCard-Heading">super mario bros.</span>
                <br></br>
              </h3>
              <span className="games-text322">
                <span>
                  super mario bros! with a level creator, mods, and the original
                  game, all in one! if it&apos;s laggy, set fps to 30 and
                  resolution to NES!
                </span>
                <br></br>
              </span>
              <a
                href="https://foss2016.github.io/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link72 button"
              >
                <span className="games-text325">
                  <span>one up!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm46">
              <h3 className="games-text328">
                <span className="BigCard-Heading">johnny upgrade.</span>
                <br></br>
              </h3>
              <span className="games-text331">
                <span>
                  play as a hero, but broke! grab some cash and buy your way to
                  the top!
                </span>
                <br></br>
              </span>
              <a
                href="https://google-opensocial.googleusercontent.com/gadgets/ifr?url=https://s3.amazonaws.com/production-assetsbucket-8ljvyr1xczmb/f107b843-3661-4036-9397-2b0c6414a369%2Fjohnny-upgrade.xml&amp;container=ig"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link73 button"
              >
                <span className="games-text334">
                  <span>get that bling!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm47">
              <h3 className="games-text337">
                <span className="BigCard-Heading">rooftop snipers!</span>
                <br></br>
              </h3>
              <span className="games-text340">
                <span>
                  fire away at your pals, and fling them off the rooftop!
                </span>
                <br></br>
              </span>
              <a
                href="https://script.google.com/macros/s/AKfycbyoVKqSi44yCkcl01rp17c7Dluj_4Q9P5kSsqGcf02xgBTx_mT6jik17o2mhkGgd9Yj/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link74 button"
              >
                <span className="games-text343">
                  <span>fire away!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm48">
              <h3 className="games-text346">
                <span className="BigCard-Heading">Gunblood.</span>
                <br></br>
              </h3>
              <span className="games-text349">
                <span>
                  place your mouse on the chamber, and fire at the enemy with
                  haste! now with friend leaderboards~
                </span>
                <br></br>
              </span>
              <a
                href="https://script.google.com/macros/s/AKfycbwrC64nl7D5u4ABIjEEb_vpJU83n4zUMxe4Yf0HbaOL9EEo6gg6L-T_KIZ69HLtdSiT/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link75 button"
              >
                <span className="games-text352">
                  <span>Draw!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm49">
              <h3 className="games-text355">
                <span className="BigCard-Heading">bloons tower defense 5!</span>
                <br></br>
              </h3>
              <span className="games-text358">
                <span>
                  a poptacular classic tower defense game. the game isnt broken,
                  it takes a while to load.
                </span>
                <br></br>
              </span>
              <a
                href="https://script.google.com/macros/s/AKfycbzSjvvBl4oIbQbsdQ6wORkEPqBumZKhlNUW3FirGHuAIe6EPZ_QGuF4N0TqjL0ECFoo/exec"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link76 button"
              >
                <span className="games-text361">
                  <span>pop!</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm50">
              <h3 className="games-text364">
                <span className="BigCard-Heading">ULTRAKILL</span>
                <br></br>
              </h3>
              <span className="games-text367">
                <span>JUDGEMENT</span>
                <br></br>
              </span>
              <a
                href="https://map-l.github.io/play/ultrakill/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link77 button"
              >
                <span className="games-text370">
                  <span>p rank this you casual</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm51">
              <h3 className="games-text373">
                <span className="BigCard-Heading">hollow knight</span>
                <br></br>
              </h3>
              <span className="games-text376">
                <span>
                  yes, its the full game. yes there is no catch, yes your
                  chromebook wont have fun
                </span>
                <br></br>
              </span>
              <a
                href="https://v6-f.knimedia.us/books/hollow-knight/index.html"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link78 button"
              >
                <span className="games-text379">
                  <span>112% clear WOOOT</span>
                  <br></br>
                </span>
              </a>
            </div>
            <div className="games-thq-card-content-elm52">
              <h3 className="games-text382">
                <span className="BigCard-Heading">R.E.P.O</span>
                <br></br>
              </h3>
              <span className="games-text385">
                <span>
                  yes, its the full game. yes there is no catch, yes your
                  chromebook wont have fun
                </span>
                <br></br>
              </span>
              <a
                href="https://map-l.github.io/play/repo/"
                target="_blank"
                rel="noreferrer noopener"
                className="games-link79 button"
              >
                <span className="games-text388">
                  <span>i love, i luh hove...</span>
                  <br></br>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Games
